const creditOperationLabels: Record<string, string> = {
  GRANT: '增加积分',
  DEDUCT: '扣减积分',
};

const creditChangeTypeLabels: Record<string, string> = {
  CONSUME: '消费扣减',
  GRANT: '积分发放',
  RETURN: '积分返还',
  EXPIRE: '过期扣减',
};

const creditStatusLabels: Record<string, string> = {
  PENDING: '处理中',
  DONE: '已完成',
  FAILED: '失败',
  REVERSED: '已冲销',
};

const creditAssetTypeLabels: Record<string, string> = {
  daily_free: '每日免费积分',
  login_free: '首次登录积分',
  ops_grant: '运营发放积分',
  credits_pack_purchase: '积分包购买',
  membership_period_grant: '会员周期积分',
};

function enumLabel(labels: Record<string, string>, value: string) {
  const normalized = value.trim();
  return labels[normalized] || normalized || '-';
}

export function creditOperationLabel(value: string) {
  return enumLabel(creditOperationLabels, value);
}

export function creditChangeTypeLabel(value: string) {
  return enumLabel(creditChangeTypeLabels, value);
}

export function creditStatusLabel(value: string) {
  return enumLabel(creditStatusLabels, value);
}

export function creditAssetTypeLabel(value: string) {
  return enumLabel(creditAssetTypeLabels, value);
}
